export default {"src":"/_next/static/media/caret-left-logo.a9aecd74.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};